import { render } from "./PhoneNumber.vue?vue&type=template&id=365f07d7&scoped=true&ts=true"
import script from "./PhoneNumber.vue?vue&type=script&lang=ts"
export * from "./PhoneNumber.vue?vue&type=script&lang=ts"

import "./PhoneNumber.vue?vue&type=style&index=0&id=365f07d7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365f07d7"]])

export default __exports__